/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export function noop(...args: any[]): any {
  // Do nothing.
}



// WEBPACK FOOTER //
// ../../../../../packages/core/src/util/noop.ts